<template>
  <div>
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h3>Editar categoría</h3>
          <!-- Form -->
          <b-form @submit.stop.prevent="onSubmit">
            <b-alert :show="form.error.show" variant="danger">{{
              form.error.text
            }}</b-alert>

            <b-form-row>
              <b-form-group
                :key="lang"
                v-for="(lang, i) in languageCodes"
                :id="'input-reference_' + lang"
                :label="'Nombre (' + languageNames[i] + ')'"
                :label-for="'reference_' + lang"
                class="col-3"
              >
                <b-form-input
                  :id="'reference_' + lang"
                  v-model="$v.form['reference_' + lang].$model"
                  :state="validateState('reference_' + lang)"
                  :aria-describedby="'input-reference_' + lang + '- feedback'"
                ></b-form-input>
                <b-form-invalid-feedback
                  :id="'input-reference_' + lang + '-feedback'"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <b-form-row>
              <b-form-group
                :key="lang"
                v-for="(lang, i) in languageCodes"
                :id="'input-slug_' + lang"
                :label="'Slug (' + languageNames[i] + ')'"
                :label-for="'slug_' + lang"
                class="col-3"
              >
                <b-form-input
                  :id="'slug_' + lang"
                  v-model="$v.form['slug_' + lang].$model"
                  :state="validateState('slug_' + lang)"
                  :aria-describedby="'input-slug_' + lang + '- feedback'"
                ></b-form-input>
                <b-form-invalid-feedback
                  :id="'input-slug_' + lang + '-feedback'"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <b-form-row>
              <!-- Reference
              <b-form-group
                id="input-reference"
                class="col-3"
                label="Nombre"
                label-for="reference"
              >
                <b-form-input
                  id="reference"
                  v-model="$v.form.reference.$model"
                  :state="validateState('reference')"
                  aria-describedby="input-reference-feedback"
                ></b-form-input>
                <b-form-invalid-feedback id="input-reference-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group> -->

              <b-form-group
                id="input-parent"
                class="col-3"
                label="Categoría madre"
                label-for="parent"
              >
                <b-form-select
                  :options="parentOptions"
                  id="parent"
                  v-model="$v.form.parent.$model"
                  :state="validateState('parent')"
                  aria-describedby="input-parent-feedback"
                ></b-form-select>
                <b-form-invalid-feedback id="input-parent-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                id="input-image"
                class="col-3"
                label="Imagen"
                description="Dejar vacío para mantener la imagen actual"
                label-for="image"
              >
                <b-form-file
                  accept="image/*"
                  id="image"
                  v-model="$v.form.image.$model"
                  @input="changedImage"
                  :state="validateState('image')"
                  aria-describedby="input-image-feedback"
                  drop-placeholder="Arrastra un archivo aquí..."
                ></b-form-file>
                <b-form-invalid-feedback id="input-image-feedback"
                  >Debes seleccionar una imagen válida (formato PNG o
                  JPEG).</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                label="Vista previa imagen"
                id="input-preview"
                class="col-auto"
              >
                <div>
                  <img style="max-height: 10rem" :src="form.imageURI" />
                </div>
              </b-form-group>
            </b-form-row>

            <!-- <b-form-row>
              <b-form-group
                :key="lang"
                v-for="(lang, i) in languageCodes"
                :id="'input-name_' + lang"
                :label="'Nombre (' + languageNames[i] + ')'"
                :label-for="'name_' + lang"
                class="col-3"
              >
                <b-form-input
                  :id="'name_' + lang"
                  v-model="$v.form['name_' + lang].$model"
                  :state="validateState('name_' + lang)"
                  :aria-describedby="'input-name_' + lang + '- feedback'"
                ></b-form-input>
                <b-form-invalid-feedback
                  :id="'input-name_' + lang + '-feedback'"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>
            <b-form-row>
              <b-form-group
                :key="lang"
                v-for="(lang, i) in languageCodes"
                :id="'input-description_' + lang"
                :label="'Descripción (' + languageNames[i] + ')'"
                :label-for="'description_' + lang"
                class="col-3"
              >
                <b-form-textarea
                  :id="'description_' + lang"
                  v-model="$v.form['description_' + lang].$model"
                  :state="validateState('description_' + lang)"
                  :aria-describedby="'input-description_' + lang + '- feedback'"
                ></b-form-textarea>
                <b-form-invalid-feedback
                  :id="'input-description_' + lang + '-feedback'"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row> -->

            <b-button type="submit" variant="primary"
              >Guardar categoría</b-button
            >
          </b-form>
          <!-- /Form -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {
  required,
  minLength,
  decimal,
  minValue,
} from 'vuelidate/lib/validators';

import { actions } from '@/admin/api.js';

import store from '@/admin/store.js';
import { validationMixin } from 'vuelidate';

import { helpers } from 'vuelidate/lib/validators';

const isValidImage = (image) =>
  !helpers.req(image) || ['image/jpeg', 'image/png'].includes(image['type']);

export default {
  name: 'AdminPredefinedProductCategoriesEditScreen',
  props: ['id'],
  components: {},
  mixins: [validationMixin],
  validations() {
    let rules = {
      // reference: {
      //   required,
      // },
      // name: {
      //   required,
      // },
      // description: {
      //   required,
      // },
      parent: {},
      image: { isValidImage },
    };

    this.languageCodes.map((x) => {
      // Only 'es' lang required
      rules['reference_' + x] = { required };
      rules['slug_' + x] = { required };
    });

    return {
      form: rules,
    };
  },
  data() {
    let form = {
      // name: '',
      // description: '',
      reference: '',
      parent: null,
      image: null,
      imageURI: null,
      error: {
        show: false,
        text: '',
      },
    };

    store.getLanguageCodes().map((x) => {
      form['reference_' + x] = '';
      form['slug_' + x] = '';

      // form['description_' + x] = '';
    });

    return {
      sharedState: store.state,
      languageCodes: store.getLanguageCodes(),
      languageNames: store.getLanguageNames(),
      parentOptions: [],
      form: form,
    };
  },
  created() {
    actions.getPredefinedProductCategoriesUnpaginated().then((x) => {
      this.parentOptions = x.data.results.map((y) => {
        return {
          value: y.id,
          text: y.reference,
        };
      });

      this.parentOptions.push({ value: null, text: '-' });

      if (this.id !== 'new') {
        actions.getPredefinedProductCategory(this.id).then((z) => {
          const data = z.data;

          this.form.reference = data.reference;
          // this.form.name = data.name;
          // this.form.description = data.description;
          this.form.parent = data.parent;

          this.languageCodes.map((y) => {
            this.form['reference_' + y] = data['reference_' + y];
            this.form['slug_' + y] = data['slug_' + y];

            // this.form['description_' + y] = data['description_' + y];
          });
        });
      }
    });
  },
  methods: {
    getDataURIFromFile(file) {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.onload = () => resolve(fileReader.result);
        fileReader.readAsDataURL(file);
      });
    },
    changedImage(newFile) {
      this.getDataURIFromFile(newFile).then((result) => {
        this.form.imageURI = result;
      });
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      store.setOverlayShow(true);

      let data = {};
      let dataimg = new FormData();

      if (this.form.image !== null) {
        dataimg.append('image', this.form.image);
      }

      data['parent'] = this.form.parent;
      data['reference'] = this.form.reference_es;
      data['slug'] = this.form.slug_es;

      this.languageCodes.map((x) => {
        data['reference_' + x] = this.form['reference_' + x];
        data['slug_' + x] = this.form['slug_' + x];

        // data['description_' + x] = this.form['description_' + x];
      });

      if (this.id === 'new') {
        actions.postPredefinedProductCategory(data).then((x) => {
          actions
            .patchPredefinedProductCategory(x.data.id, dataimg)
            .then((y) => {
              this.$router.push({
                name: 'AdminPredefinedProductCategoriesScreen',
              });
            });
        });
      } else {
        Promise.all([
          actions.patchPredefinedProductCategory(this.id, data),
          actions.patchPredefinedProductCategory(this.id, dataimg),
        ]).then((x) => {
          this.$router.push({
            name: 'AdminPredefinedProductCategoriesScreen',
          });
        });
      }

      // this.languageCodes.map((x) => {
      //   data['name_' + x] = this.form['name_' + x];
      //   data['description_' + x] = this.form['description_' + x];
      // });

      // data['name'] = this.form['name_' + this.languageCodes[0]];
      // data['description'] = this.form['description_' + this.languageCodes[0]];
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
